// TODO: Replace with common tagIds enum
enum TagId {
  PriceDrop = 103,
  GreatDeal = 104,
  RecentlyAdded = 121
}

export default TagId;
